import { Component, Input } from "@angular/core";

// https://ultimatecourses.com/blog/transclusion-in-angular-2-with-ng-content

/**
 * Re-Usable loading-animation.
 *
 *
 * @example
 * <circ-loader [isLoading]="true"></circ-loader>
 *
 * @example
 * <circ-loader [isLoading]="false">This text will show!</circ-loader>
 *
 * @example
 * <circ-loader [isLoading]="true" size="10em" color="#ff0000"></circ-loader>
 *
 */
@Component({
    selector: "circ-loader",
    templateUrl: "./loader.component.html",
    styleUrls: ["./loader.component.scss"],
    standalone: false
})
export class LoaderComponent {
  /**
   * color to use for the animation
   */
  @Input() public color;

  /**
   * When this is true, the loading-animation will show, the content will not show
   */
  @Input() public isLoading = true;

  /**
   * When this is true, the content will be removed from DOM instead of "display:none"
   */
  @Input() public removeContentWhileLoading = false;

  /**
   * size to use for the animation
   */
  @Input() public size = "64px";

  /**
   * margin-top to use for the animation
   */
  @Input() public marginTop = "25%";

  /**
   * height of the control
   */
  @Input() public height = "100%";

  /**
   * width of the control
   */
  @Input() public width = "100%";

  /**
   * background of the control
   */
  @Input() public background = "rgba(0, 0, 0, 0.1)";
}
